<script setup lang="ts">
import { getAlmInfo } from "@/backend/read/BackendReader";
import SelectableList from "@/components/ui/SelectableList/SelectableList.vue";
import SvgIcon from "@/components/ui/SvgIcon/SvgIcon.vue";
import TypeDot from "@/components/ui/TypeDot/TypeDot.vue";
import type { StickyType } from "@/model/stickyType";
import { isStickyTypeAlmSynced } from "@/store/stickyType";

defineProps<{
  header?: string;
  modelValue?: StickyType | readonly StickyType[];
  stickyTypes: StickyType[];
  disabled?: boolean;
  isItemDisabled?: (item: StickyType) => boolean;
  disabledMessage?: string;
}>();

const emit = defineEmits<{ "update:model-value": [value: StickyType | readonly StickyType[]] }>();
</script>

<template>
  <SelectableList
    role="dialog"
    :header="header || $t('general.stickyTypes')"
    :aria-label="header || $t('general.stickyTypes')"
    :model-value
    :values="stickyTypes"
    :disabled
    :is-item-disabled
    :disabled-message
    @update:model-value="emit('update:model-value', $event)"
  >
    <template #before="{ item }">
      <TypeDot size="medium" :color="item.color" />
    </template>
    <template #default="{ item }">
      {{ item.name }}
    </template>
    <template #after="{ item }">
      <SvgIcon
        v-if="isStickyTypeAlmSynced(item)"
        :name="getAlmInfo().icon"
        width="15"
        height="15"
      />
    </template>
  </SelectableList>
</template>
